// @flow

import {Tag} from 'docs/util';

import type {MarkdocNodeRegistration} from 'docs/markdoc';

const getAnchor = (children, attributes): string => {
  if (attributes.id && typeof attributes.id === 'string') {
    return attributes.id;
  }
  return children
    .filter((child) => typeof child === 'string')
    .join(' ')
    .replace(/[?]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase();
};

export const Heading: MarkdocNodeRegistration = {
  node: 'heading',
  component: 'Heading',
  children: ['inline'],
  attributes: {
    toc: {type: String},
    level: {type: Number, required: true, default: 1},
    anchored: {type: Boolean, default: true},
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    const id = getAnchor(children, attributes);

    // This generates a `toc` attribute value for level 2 headings
    // To get the heading title as plain text, it recursively walks the AST and
    // concatenates all of the text nodes, ignoring other tags and formatting.
    let {toc} = node.attributes;
    const {level} = node.attributes;

    if (!toc && level === 2) {
      toc = '';
      for (const child of node.walk()) {
        if (
          child.type === 'text' &&
          typeof child.attributes.content === 'string'
        ) {
          toc += child.attributes.content;
        }
      }
    }

    return new Tag(this.tag, {...attributes, toc, id}, children);
  },
};
